<account-menu [selectedMenu]="8" [me]="me"></account-menu>

<div class="col-lg-9 col-md-9 col-sm-8 content-panel-wrapper no-padding-mobile">

  <h2 class="page-title">Settings</h2>

  <div class="page-sub-title">Personalise your account preferences</div>

  <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
    <div class="panel" *ngIf="!myForm.controls['newPassword'].valid">
      <div class="panel-title">Password Guidance</div>

      <div class="pass-error">
        <div class="col-sm-12">
          <p>
            To ensure your password is as safe as possible please use a combination of the following characters:
          </p>
          <div class="col-sm-6 nopadding-left">
            <ul>
              <li>- Minimum 8 characters</li>
              <li>- Lowercase letters</li>
              <li>- Uppercase letters</li>
            </ul>
          </div>

          <div class="col-sm-6 nopadding-left">
            <ul>
              <li>- Numbers</li>
              <li>- Special characters:</li>
              <li>&nbsp; !, @, #, $, %, ^, &</li>
            </ul>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <div class="panel">
      <div class="col-sm-8 col-sm-offset-2" *ngIf="myForm.controls['newPassword'].valid">
        <div class="pass-ok">
          <h4>Password Acceptable</h4>
        </div>
        <div class="clear"></div>
      </div>

      <div class="clear"></div>

      <div class="col-sm-6 no-padding-mobile">
        <div class="form-elem">
          <div class="form-elem-name">Password</div>
          <div class="form-elem-field">
            <div class="formsec-field-a"><input type="password" [formControl]="myForm.controls['newPassword']"
                [(ngModel)]="model.newPassword" /></div>
            <div class="mb-error-fail-wrap"
              *ngIf="!myForm.controls['newPassword'].valid && myForm.controls['newPassword'].touched">
              <div class="mb-error-fail">Please enter a Stronger Password</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6 no-padding-mobile">
        <div class="form-elem">
          <div class="form-elem-name">Confirm Password</div>
          <div class="form-elem-field">
            <div class="formsec-field-a"><input type="password" [formControl]="myForm.controls['confirmPassword']"
                [(ngModel)]="model.confirmPassword" /></div>
            <div class="mb-error-fail-wrap"
              *ngIf="!myForm.controls['confirmPassword'].valid && myForm.controls['confirmPassword'].touched">
              <div class="mb-error-fail">Please Confirm Password</div>
            </div>
          </div>
        </div>
      </div>

      <div class="clear"></div>
    </div>

    <div class="col-sm-12 form-elem nopadding">
      <div class="col-xs-6">
        <button type="submit" class="btn-main-proceed">Save</button>
      </div>

      <div class="col-xs-6">
        <button type="button" class="btn-main-caution" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </form>
</div>
